import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect during email verification flow
    const isEmailVerificationFlow =
      location.pathname.includes('verify-email') ||
      location.pathname.includes('activation') ||
      location.pathname.includes('__/auth/action') ||
      location.pathname.includes('reset-password');

    // Only redirect if logged in AND we're not in the email verification flow
    if (isLoggedIn && !isEmailVerificationFlow) {
      navigate(location?.state?.from ? location?.state?.from : APP_DEFAULT_PATH, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location, user]);

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
